<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="$t('Confirm the order')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="body">
            <!-- 地址 -->
            <div class="block-wrapper">
                <checkout-address class="address" v-on:onclick="goAddress" :item="address_info"></checkout-address>
            </div>
            <!-- 商品详情 -->

            <div class="section-header">
                <div class="cart-item" :show-border="true">
                    <div>
                        <div class="store">
                            <i class="iconfont">&#xe62d;</i>
                            <span>{{ 'gobuy' }}</span>
                        </div>
                        <div class="buy-item">
                            <div class="goods-pic">
                                <img :src="objData.image || objData.goods_image" />
                            </div>
                            <div class="goods-info">
                                <dl>
                                    <dt class="goods-name">
                                        {{ objData.goods_name }}
                                    </dt>
                                    <dd class="goods-subtotal">
                                        <span class="goods-price">${{ objData.usd }}</span>
                                        <span class="goods-count">×1</span>
                                    </dd>
                                </dl>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- 价格备注 -->
            <div class="cart-subtotal"></div>
        </div>
        <div class="bottom-wrapper">
            <div class="amount-wrapper" @click="onGetGoods()">
                <div class="common-btn ds-button-large">{{ $t('Submit an order') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import { GetAddressInfo, GetGoods } from '../../../api/memberOne'
import CheckoutAddress from '../buy/child/CheckoutAddress.vue'

export default {
    name: 'Pickup',
    components: {
        CheckoutAddress,
    },
    data() {
        return {
            store_final_total_list: null,
            address_info: {},
            value: ''
        }
    },
    props: {
        one: {
            default: false,
            type: Boolean
        },
        objData: {
            default: () => { },
            type: Object
        }
    },
    created: function () {
        console.log(this.objData)
        this.onGetAddressInfo()
    },
    methods: {
        onGetAddressInfo() {
            GetAddressInfo({}).then(res => {
                if (res && res.result) {
                    this.address_info = res.result || {}
                }
            })
        },
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
        goAddress() {
            if (this.address_info) {
                this.$router.push({ name: 'MemberAddressList' })
            } else {
                this.$router.push({
                    name: 'MemberAddressForm',
                    query: {
                        action: 'add',
                        isFromCheckout: true,
                        goBackLevel: -1
                    }
                })
            }
        },
        onGetGoods() {
            const activity_id = this.objData.activity_id ? this.objData.activity_id : this.objData.id
            GetGoods({
                activity_id,
            }, 'one').then(res=>{
                Toast(res.message)
                if(res.code == 10000) {
                    setTimeout(() => {
                        this.$emit('onPage', 'index')
                    }, 1000);
                }else if(res.code == 10010){
                    setTimeout(()=>{
                        this.$router.push({ name: 'MemberAddressForm' })
                    },100)
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.common-header {
    .btn {
        background: #000;
        color: #fff;
        box-shadow: 0px 2px 4px #d2d2d2;
    }
}

.block-wrapper {
    background: #fff;
    padding: 0 $pageSpace
}

.container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
}

.header {
    height: 2.2rem;
    color: #48505d;
    font-size: $h1;
    background-color: #fff;
    padding: 0.1rem 0;
    border-bottom: 1px solid #e8eaed;
}

.body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    margin-bottom: 4rem;
}

.goods {
    height: 4.5rem;
}

.item {
    height: 2.5rem;
}

.section-header {
    margin-top: 0.4rem;
}

.section-footer {
    margin-bottom: 0.4rem;
}

.comment {
    height: 7.25rem;
}

.desc {
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.desc-item {
    height: 1.5rem;
}

.bottom-wrapper {
    z-index: 1;
    // background: #fff;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 5%;
    padding: .5rem 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
}

.amount-wrapper {
    flex: 1;
    // background-color: #fff;
    margin: 0 $pageSpace;
}

.amount {
    flex: 1;
    font-size: $h2;
    color: $primaryColor;
    text-align: right;
    padding-right: 0.75rem;
}

.submit {
    width: 7.5rem;
    height: 2.5rem;
    border-radius: 0;
}

.common-voucher {
    margin: 0.5rem auto
}

.left-icon {
    float: left;
    font-size: $h1;
    margin-right: 0.2rem;
}

.desc-text {
    font-size: $subFontSize;
    color: #999;
    padding: 1rem
}

.section-header {
    margin-top: 0.4rem;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    background: #fff;
    padding: 0 0.6rem;
}

.store {
    position: relative;
    z-index: 1;
    display: block;
    height: 0.9rem;
    padding: 0.5rem 0;
    font-size: $subFontSize;
    line-height: 0.9rem;
    background: #fff;
    font-weight: 700;
}

.store i {
    font-size: $h2;
    margin-right: 0.2rem;
    color: $primaryColor;
}

.cart-item {
    background-color: #FFF;
}

.buy-item {
    display: block;
    position: relative;
    z-index: 1;
    margin: .5rem 0;
    box-shadow: 0px 4px 4px #f7f7f7;
}

.buy-item .goods-pic {
    display: block;
    width: 3rem;
    height: 3rem;
    position: absolute;
    z-index: 1;
    top: 0rem;
    left: 0rem;
}

.buy-item .goods-pic img {
    width: 100%;
    height: 100%;
    border-radius: 0.2rem;
    -o-object-fit: contain;
    object-fit: contain;
}

.buy-item .goods-info {
    display: block;
    // vertical-align: top;
    padding: .2rem 0;
    margin-left: 4rem;
    position: relative;
    z-index: 1;
}

.buy-item .goods-info .link {
    font-size: $subFontSize;
    color: $primaryColor;
    margin-top: .3rem
}

.buy-item .goods-info .goods-name {
    height: 1.6rem;
    font-size: $subFontSize;
    line-height: .8rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: box;
    line-clamp: 2;
    box-orient: vertical;
    margin-bottom: .5rem;
    font-weight: normal;

    .tag-icon {
        vertical-align: top
    }
}

.buy-item .goods-info .goods-type {
    overflow: hidden;
    white-space: nowrap;
    width: 70%;
    height: 0.9rem;
    font-size: $h6;
    line-height: 0.9rem;
    color: #999;
    text-overflow: ellipsis;
}

.buy-item .goods-info .goods-original-price {
    text-decoration: line-through;
    font-size: $fontSize;
    color: $descTextColor;
    font-weight: normal
}

.buy-item .goods-info .goods-subtotal {
    display: block;
    height: 1rem;
    margin: 0 0.5rem 0 0rem;
    line-height: 1rem;
    font-size: $subFontSize;
    position: relative;
    z-index: 1;
}

.buy-item .goods-info .goods-subtotal .goods-price {
    color: #DB4453;
    font-size: $subFontSize;
    font-weight: 600;
}

.buy-item .goods-info .goods-subtotal .goods-count {
    font-size: $subFontSize;
    line-height: 1rem;
    position: absolute;
    z-index: 1;
    top: 0rem;
    right: 0rem;
    font-weight: normal;
    color: $descTextColor
}

.cart-subtotal .message {
    position: relative;
    z-index: 1;
    display: block;
    border-bottom: 1px dashed #eee;

    .order-message {
        background: #FBFBFB;
        margin: .5rem 0;
        font-size: $fontSize;
        padding: .5rem;
        height: 4rem;
        border: 0;
        box-sizing: border-box;
        width: 100%;
    }
}
</style>
